import React, { FC } from 'react'

import { Typography } from '@smarty-nx/ds'

import { coverageCheckerContent } from './coverage-checker.content'
import classes from './coverage-checker.module.scss'
import VodafoneThreeLogo from '../../static/images/VodafoneThreeLogo.webp'
import { Icon } from '../shared'
import TextLink from '../TextLink'

export const CoverageChecker: FC = () => (
  <div className={classes.wrapper} data-testid="coverage-checker">
    <Typography variant="Base/Body" className={classes.coverageParagraph}>
      <TextLink to="/coverage-checker" dataTestId="coverage-checker-link">
        {coverageCheckerContent.checkCoverageLabel}
      </TextLink>
      {coverageCheckerContent.poweredByText}
    </Typography>
    <Icon
      src={VodafoneThreeLogo}
      width="auto"
      height="45px"
      margin="0 0 0 10px"
      alt={coverageCheckerContent.poweredByLogoAlt}
      loading="lazy"
      data-testid="three-icon"
    />
  </div>
)

export default CoverageChecker
